var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "guide-tour",
          attrs: { tabindex: "0" },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              return _vm.skipTour.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "guide-overlay" }),
          _vm._v(" "),
          _vm.currentStep
            ? _c("div", { staticClass: "guide-focus", style: _vm.focusStyle })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep
            ? _c("div", { staticClass: "guide-message" }, [
                _c("div", { staticClass: "message-content" }, [
                  _c("p", [_vm._v(_vm._s(_vm.currentStep.message))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "guide-controls" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          attrs: {
                            disabled: _vm.currentStepIndex === 0,
                            ghost: "",
                            primary: "",
                            xlarge: "",
                          },
                          on: { click: _vm.previousStep },
                        },
                        [
                          _vm._v(
                            "\n                    Geri\n                    "
                          ),
                          _c("span", { staticClass: "shortcut" }, [
                            _vm._v("[←]"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { ghost: "", primary: "", xlarge: "" },
                          on: { click: _vm.skipTour },
                        },
                        [
                          _vm._v(
                            "\n                    Atla\n                    "
                          ),
                          _c("span", { staticClass: "shortcut" }, [
                            _vm._v("[ESC]"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: {
                            primary: _vm.isLastStep,
                            primary: "",
                            ghost: "",
                            xlarge: "",
                          },
                          on: { click: _vm.nextStep },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.isLastStep ? "Bitir" : "İleri") +
                              "\n                    "
                          ),
                          _c("span", { staticClass: "shortcut" }, [
                            _vm._v("[→]"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.arrowStyle.display
            ? _c(
                "div",
                {
                  staticClass: "guide-arrow",
                  style: {
                    top: _vm.arrowStyle.top + "px",
                    left: _vm.arrowStyle.left + "px",
                    width: _vm.arrowStyle.width + "px",
                    height: _vm.arrowStyle.height + "px",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: _vm.arrowStyle.width,
                        height: _vm.arrowStyle.height,
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        stroke: "url(#arrowGradient)",
                        "stroke-width": "3",
                      },
                    },
                    [
                      _c(
                        "defs",
                        [
                          _c(
                            "linearGradient",
                            {
                              attrs: {
                                id: "arrowGradient",
                                x1: "0%",
                                y1: "0%",
                                x2: "100%",
                                y2: "100%",
                              },
                            },
                            [
                              _c("stop", {
                                staticStyle: { "stop-color": "#ff6b6b" },
                                attrs: { offset: "0%" },
                              }),
                              _vm._v(" "),
                              _c("stop", {
                                staticStyle: { "stop-color": "#4ecdc4" },
                                attrs: { offset: "50%" },
                              }),
                              _vm._v(" "),
                              _c("stop", {
                                staticStyle: { "stop-color": "#45b7d1" },
                                attrs: { offset: "100%" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: _vm.arrowPath,
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _vm.arrowHeadPoints
                        ? _c("polygon", {
                            attrs: {
                              points: _vm.arrowHeadPoints,
                              fill: "url(#arrowGradient)",
                              stroke: "none",
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }